export default "__VITE_ASSET__7e587668__"